<app-context-menu-heading>Sorting options:</app-context-menu-heading>

@if ((withAdvancedSearch && advancedSearchApplied) || withScore) {
  <app-context-menu-item
    [withCheckOption]="true"
    title="Relevance"
    [active]="state.sortBy === 'score'"
    [sortable]="true"
    [reversed]="state.sortOrder === 'desc'"
    (execute)="sort('score')"
    />
}

<app-context-menu-item
  [withCheckOption]="true"
  title="Title"
  [active]="state.sortBy === 'title'"
  [sortable]="true"
  [reversed]="state.sortOrder === 'desc'"
  (execute)="sort('title')"
  />

  <app-context-menu-item
    [withCheckOption]="true"
    title="Created date"
    [active]="state.sortBy === 'createdAt'"
    [sortable]="true"
    [reversed]="state.sortOrder === 'desc'"
    (execute)="sort('createdAt')"
    />

    <app-context-menu-item
      [withCheckOption]="true"
      title="Updated date"
      [active]="state.sortBy === 'updatedAt'"
      [sortable]="true"
      [reversed]="state.sortOrder === 'desc'"
      (execute)="sort('updatedAt')"
      />

      <app-context-menu-divider />

      <app-context-menu-item
        [withCheckOption]="true"
        title="Pinned on top"
        [active]="state.pinnedOnTop"
        (execute)="pinnedOnTop()"
        />

@if (virtualFolder() !== 'flagged') {
        <app-context-menu-item
          [withCheckOption]="true"
          title="Flagged on top"
          [active]="state.flaggedOnTop"
          (execute)="flaggedOnTop()"
          />
}

          <app-context-menu-heading>Filters:</app-context-menu-heading>

          <app-stitch-type-context-menu-item
            [withCheckOption]="true"
            title="Stitch"
            [state]="state.stitchedWith"
            (onSelect)="stitch($event)"
            />

            <app-context-menu-divider />

            <app-context-menu-item
              [withCheckOption]="true"
              title="Flagged"
              [active]="state.flagged"
              (execute)="flag()"
              />

              <app-context-menu-item
                [withCheckOption]="true"
                title="Pinned"
                [active]="state.pinned"
                (execute)="pin()"
                />

              @if (withScore) {
                <!-- KP alone offers this: it ranks by relevance, so nothing else there narrows to today. -->
                <app-context-menu-item
                  [withCheckOption]="true"
                  title="Today"
                  [active]="state.today"
                  (execute)="today()"
                  />
              }
